
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Systembenglore() {



  const cardData =
  {
    keyword: 'Patient Thermoregulation System in Bengaluru',
    heading: 'Pharmacle Health Care Private Limited: Patient Thermoregulation System in Bengaluru',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Thermoregulation System in Bengaluru, ensuring precise temperature management for patients during surgeries and critical care. Our advanced thermoregulation systems help prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our patient thermoregulation systems are reliable, easy to use, and designed with cutting-edge technology. Choose Pharmacle Health Care for the best thermoregulation solutions in Bengaluru to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Advanced Patient Thermoregulation System in Bengaluru for Optimal Care",
    "description": "Pharmacle Health Care Private Limited offers top-tier patient thermoregulation systems in Bengaluru, ensuring precise temperature management for surgical, ICU, and neonatal care. Our advanced systems prevent hypothermia, improve recovery rates, and enhance patient outcomes."
  },
  {
    "title": "Best Patient Thermoregulation System in Bengaluru for Hospitals & Clinics",
    "description": "Maintain accurate body temperature control with Pharmacle Health Care Private Limited’s cutting-edge thermoregulation systems. Designed for hospitals and clinics in Bengaluru, these devices reduce surgical risks and improve safety during intensive care treatments."
  },
  {
    "title": "Reliable Patient Thermoregulation Solutions in Bengaluru for Critical Care",
    "description": "Pharmacle Health Care Private Limited provides efficient and reliable thermoregulation systems for patients in critical care settings. Trusted by leading hospitals in Bengaluru, our devices deliver consistent temperature control for better clinical outcomes."
  },
  {
    "title": "High-Quality Patient Thermoregulation System in Bengaluru for Precision Care",
    "description": "Pharmacle Health Care Private Limited supplies technologically advanced thermoregulation systems in Bengaluru, ensuring consistent patient warming and cooling. Our premium devices are designed for hospitals and healthcare facilities requiring precision care."
  },
  {
    "title": "Buy Patient Thermoregulation System in Bengaluru for Superior Medical Support",
    "description": "Pharmacle Health Care Private Limited offers high-performance thermoregulation systems in Bengaluru for surgical, trauma, and neonatal applications. Our solutions provide superior medical support, enabling hospitals to deliver safe and efficient patient care."
  },
  {
    "title": "State-of-the-Art Patient Thermoregulation System in Bengaluru for Enhanced Safety",
    "description": "Pharmacle Health Care Private Limited delivers state-of-the-art thermoregulation systems in Bengaluru, engineered to ensure precise body temperature control. These devices minimize perioperative risks and enhance overall patient safety in hospitals."
  },
  {
    "title": "Affordable & Effective Patient Thermoregulation System in Bengaluru",
    "description": "Pharmacle Health Care Private Limited provides cost-effective thermoregulation solutions in Bengaluru, allowing hospitals and clinics to maintain stable patient body temperatures. Our devices reduce post-surgical complications while improving patient comfort."
  },
  {
    "title": "Trusted Supplier of Patient Thermoregulation Systems in Bengaluru",
    "description": "Pharmacle Health Care Private Limited is a trusted supplier of patient thermoregulation systems in Bengaluru. Leading medical institutions rely on our solutions for accurate and controlled thermal support in ICUs and surgical care units."
  },
  {
    "title": "Pediatric & Adult Patient Thermoregulation System in Bengaluru",
    "description": "Pharmacle Health Care Private Limited offers thermoregulation systems suitable for neonatal, pediatric, and adult patients. Hospitals in Bengaluru depend on our devices for safe, effective, and reliable temperature management across all age groups."
  },
  {
    "title": "Hospital-Grade Patient Thermoregulation System in Bengaluru for Superior Results",
    "description": "Pharmacle Health Care Private Limited supplies hospital-grade thermoregulation systems in Bengaluru, designed to deliver consistent performance in ICUs, surgical centers, and recovery units. Our advanced technology ensures superior patient care results."
  }
],

      "services": [
        {
            "name": "Patient Thermoregulation System Bengaluru",
            "description": "Pharmacle Health Care offers patient thermoregulation systems in Bengaluru, designed to maintain an optimal body temperature during medical treatments. These systems help regulate temperature fluctuations, ensuring patient comfort and safety throughout surgeries and recovery."
        },
        {
            "name": "Bengaluru Forced Air Warming Devices",
            "description": "We provide forced air warming devices in Bengaluru, designed to circulate warm air and maintain body temperature during medical procedures. These devices are highly effective in preventing hypothermia, ensuring patient safety and comfort during surgeries and recovery."
        },
        {
            "name": "Patient Warming Systems Bengaluru",
            "description": "Pharmacle Health Care offers patient warming systems in Bengaluru, designed to regulate body temperature during medical treatments. These systems help prevent temperature-related complications and ensure a safe and comfortable environment for patients during surgeries and recovery."
        },
        {
            "name": "Bengaluru Medical Temperature Control Devices",
            "description": "We offer medical temperature control devices in Bengaluru, designed to regulate body temperature during surgeries and medical procedures. These devices prevent hypothermia and ensure a safe and controlled environment for patients during critical care and recovery."
        },
        {
            "name": "Bengaluru Hospital Warming Solutions",
            "description": "Pharmacle Health Care provides hospital warming solutions in Bengaluru, designed to regulate body temperature during medical procedures. These solutions are essential for preventing hypothermia and ensuring patient comfort and safety during surgeries and recovery."
        }
    ],
    "tableData": [
        ["- Patient Thermoregulation System Bengaluru", "- Bengaluru Forced Air Warming Devices"],
        ["- Patient Warming Systems Bengaluru", "- Bengaluru Medical Temperature Control Devices"],
        ["- Bengaluru Hospital Warming Solutions"]
    ],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient thermoregulation systems in Bengaluru, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent temperature-related complications, enhancing patient safety in hospitals and clinics across the Bengaluru region."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient thermoregulation systems in Bengaluru, including warming devices, blankets, and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient thermoregulation systems are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our systems provide optimal reliability for continuous use in medical settings throughout Bengaluru."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our patient thermoregulation systems provide controlled, gentle warmth to maintain a stable body temperature and prevent temperature-related complications during surgeries and procedures, ensuring that patients in Bengaluru are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient thermoregulation systems in Bengaluru are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient thermoregulation systems are designed for seamless integration with existing medical systems in Bengaluru. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Bengaluru to help healthcare facilities select the right patient thermoregulation systems for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our patient thermoregulation systems are designed to maintain optimal body temperature during critical medical procedures, ensuring that every patient in Bengaluru receives the highest standard of care."
    }
]





















  }

  const faqData = [
    { question: "What is a Forced Air Warming System?", answer: "A Forced Air Warming System is a medical device used to regulate and maintain a patient’s body temperature during surgeries and medical procedures. It works by blowing warm air through a special warming blanket or pad placed over the patient." },
    { question: "How does the Forced Air Warming System work?", answer: "The system works by using a blower to circulate warm air through a blanket or pad that is placed on the patient’s body. This helps prevent hypothermia by maintaining the patient’s body temperature within a safe and comfortable range." },
    { question: "Is the Forced Air Warming System available in Bengaluru?", answer: "Yes, Pharmacle Health Care Private Limited offers Patient Thermoregulation Systems in Bengaluru, providing hospitals and healthcare facilities with an effective solution to maintain patient body temperature during medical treatments." },
    { question: "What are the benefits of using a Forced Air Warming System?", answer: "The benefits include preventing hypothermia, reducing surgical complications, improving patient comfort, speeding up recovery times, and ensuring a stable body temperature throughout medical procedures." },
    { question: "How long can the Forced Air Warming System maintain the patient’s temperature?", answer: "The Forced Air Warming System can maintain the patient’s body temperature for the entire duration of the medical procedure, ensuring consistent warmth and temperature control." },
    { question: "Is the Forced Air Warming System easy to use?", answer: "Yes, the system is designed to be user-friendly, with simple controls that allow healthcare professionals to adjust the temperature settings quickly and efficiently." },
    { question: "Can the Forced Air Warming System be used for all types of surgeries?", answer: "Yes, the Forced Air Warming System is versatile and can be used in a wide range of surgeries and medical procedures, particularly those where maintaining normothermia is essential for patient safety." },
    { question: "Is the Forced Air Warming System safe for all patients?", answer: "Yes, the system is generally safe for most patients. However, it should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and avoid overheating or underheating." },
    { question: "How can I purchase a Forced Air Warming System in Bengaluru?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering the Forced Air Warming System to your healthcare facility in Bengaluru." },
    { question: "Does Pharmacle Health Care provide support for the Forced Air Warming System?", answer: "Yes, we offer complete support for the Forced Air Warming System, including installation, training for healthcare professionals, and ongoing maintenance to ensure optimal performance." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Patient Thermoregulation System from Pharmacle Health Care in our Bengaluru hospital. It has significantly improved our ability to maintain optimal patient temperature during surgeries, ensuring greater safety and comfort.',
      name: 'Dr. Ramesh Bhat',
    },
    {
      text: 'The Patient Thermoregulation System from Pharmacle Health Care has been an essential addition to our Bengaluru clinic. It helps ensure that our patients stay at a stable temperature during medical procedures, improving overall care.',
      name: 'Bengaluru Medical Center',
    }
  ];
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Thermoregulation System in Bengaluru",
    "description": "Explore advanced Patient Thermoregulation Systems in Bengaluru for effective patient temperature control and warming solutions during medical treatments. Our systems ensure optimal safety and comfort.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1985"
    }
  };
  

  


  return (
    <div>
  <Helmet>
    <title>Patient Thermoregulation System in Bengaluru | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore Patient Thermoregulation Systems in Bengaluru for effective temperature control and patient warming solutions during medical treatments. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Thermoregulation System Bengaluru, Bengaluru Forced Air Warming Devices, Patient Warming Systems Bengaluru, Bengaluru Medical Temperature Control Devices, Bengaluru Hospital Warming Solutions"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/37.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Systembenglore;